import React from "react";
import themeDark from "../../shared/themeDark";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Button, LinearProgress } from "@material-ui/core";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import api from "../../../store/api";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import { useForm, Controller } from "react-hook-form";
import YellowBox from "./YellowBox";
import Alert from "@material-ui/lab/Alert";
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

interface ChooseReasonProps {
  endTransfer: any;
  setPage: any;
  totalTransfers: number;
  endTrip: any;
  loading: any;
  setLoading: any;
  setButtonDisable: any;
  buttonDisable : any;
  errorMessage : any;
  setErrorMessage : any;
}

const useStyles = makeStyles((theme) => ({
  typoHead: {
    fontSize: 46,
    fontWeight: 700,
    color: "#FFF",

    "@media (max-width: 1024px)": {
      fontSize: 36,
    },
  },
  headingAlert: {
    padding: theme.spacing(0, 0, 2, 0),
  },
  alertRoot: {
    marginTop: 24
  },
  label: {
    fontSize: 30,

    "@media (max-width: 1024px)": {
      fontSize: 18,
    },
  },
  arrowBack: {
    padding: 0,
    minWidth: 0,
    color: "#FFF",
    marginBottom: 50,
    marginLeft: -6,

    "@media (max-width: 1024px)": {
      marginBottom: 25,
    },
  },
  input: {
    height: 95,
    color: "#FFF",
  },
  loading: {
    width: '100%',
    '& > * + *': {
        marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
}));

const ChooseReason: React.FC<ChooseReasonProps> = ({ endTransfer, setPage: setPageOuter, totalTransfers, endTrip, loading, setLoading, setButtonDisable, buttonDisable, errorMessage,setErrorMessage }: ChooseReasonProps) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(1);
  const [reasonList, setReasonList] = React.useState<{ reasonForDelayId: string; name: string }[]>([]);
  const { handleSubmit, errors, control, getValues } = useForm();
  
  React.useEffect(() => {
    setErrorMessage("")
    api.getReasonsForDelayPerUser("").then((res: any) => {
      setReasonList(res?.data?.model || []);
    });
  }, []);

  const endTransferInner = () => {
    setLoading(true);
    setErrorMessage("");
    setButtonDisable(true);
    endTransfer({ delayReason: getValues().delayReason == "Other" ? null : getValues().delayReason, notes: getValues().otherreason }).then(() => {
      setPageOuter(0);
    });
  };

  const CreateLoadingLine = (props: any): JSX.Element => {
    return (
        <div className={classes.loading}>
            <LinearProgress color="primary" />
        </div>
    )
  }

  //const endTripInner = () => {
  //  endTrip({delayReason: getValues().delayReason == "Other" ? null : getValues().delayReason, notes: getValues().otherreason }).then(() => {
  //    setPageOuter(0);
  //  })
  //}

  const handleNext = (data: any) => {
    totalTransfers != 1 ? endTransferInner() : endTransferInner();
  };

  if (page == 2)
    return (
      <MuiThemeProvider theme={themeDark}>
        <div style={{}}>
          {loading ? <CreateLoadingLine /> : null}
        </div>
        <div style={loading ? {pointerEvents: "none"} : {}}>
        <Paper
          style={{
            minHeight: "100vh",
            // overflowY: "scroll",
            padding: "57px 74px",
            borderRadius: 0,
            margin: 0,
          }}
        >
          <Button className={classes.arrowBack} onClick={() => setPage(1)}>
            <KeyboardArrowLeftIcon />
          </Button>
          <Typography variant="body1" component="div" className={classes.typoHead}>
            What was the reason for delay?
          </Typography>
          <form onSubmit={handleSubmit(endTransferInner)} autoComplete="off">
            <div style={{ display: "flex", width: "100%", marginTop: 40 }}>
              {reasonList.length > 0 && (
                <Controller
                  name="delayReason"
                  defaultValue={reasonList[0].reasonForDelayId}
                  control={control}
                  render={(props) => (
                    <>
                      <div style={{ display: "flex", width: "50%" }}>
                        <RadioGroup value={props.value} onChange={props.onChange}>
                          {reasonList.map((item: any, i) => (i <= reasonList.length / 2 ? <FormControlLabel classes={{ label: classes.label }} value={item.reasonForDelayId} control={<Radio />} label={item.name} /> : null))}
                        </RadioGroup>
                      </div>
                      <div style={{ display: "flex", width: "50%" }}>
                        <RadioGroup value={props.value} onChange={props.onChange}>
                          {reasonList.map((item: any, i) => (i > reasonList.length / 2 ? <FormControlLabel classes={{ label: classes.label }} value={item.reasonForDelayId} control={<Radio />} label={item.name} /> : null))}
                          <FormControlLabel classes={{ label: classes.label }} value="Other" control={<Radio />} label="Other" />
                        </RadioGroup>
                      </div>
                    </>
                  )}
                  rules={{ required: true }}
                />
              )}
            </div>
            <Controller
              name="otherreason"
              defaultValue=""
              control={control}
              render={(props) => (
                <TextField
                  key="otherreason"
                  placeholder="Notes..."
                  variant="outlined"
                  multiline
                  rows={4}
                  InputProps={{
                    classes: { input: classes.input },
                  }}
                  helperText={errors.otherreason ? "Notes are required" : ""}
                  style={{ marginTop: 42 }}
                  value={props.value}
                  onChange={props.onChange}
                  error={errors.otherreason}
                />
              )}
              rules={{ required: getValues().delayReason == "Other" }}
            />
            <div style={{ display: "flex", marginTop: 30, width: "100%", justifyContent: "flex-end" }}>
              <YellowBox buttonProps={{ type: "submit" }} style={{ padding: "2px 0px" }} title="Save" />
            </div>
              <div className={classes.headingAlert}>
                <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                  {errorMessage}
                </Alert>
              </div>
          </form>
        </Paper></div>
      </MuiThemeProvider>
    );
  return (
    <MuiThemeProvider theme={themeDark}>
      <div style={{}}>
        {loading ? <CreateLoadingLine /> : null}
      </div>
      <div style={loading ? { pointerEvents: "none" } : {}}>
        
        <Paper
          style={{
            height: "100vh",
            // overflowY: "scroll",
            padding: 74,
            borderRadius: 0,
          }}
        >
          <div className={classes.headingAlert}>
            <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
              {errorMessage}
            </Alert>
          </div>
          <Typography variant="body1" component="div" className={classes.typoHead}>
            Did this transfer take longer than expected?
          </Typography>
          <div style={{ display: "flex", marginTop: 24 }}>
            <YellowBox style={{ padding: "2px 0px", marginRight: 24 }} title="No" onClick={() => endTransferInner()} buttonProps={{ disabled: (buttonDisable ? true : false) }} />
            <YellowBox style={{ padding: "2px 0px" }} title="Yes" onClick={() => setPage(2)} />
          </div>
        </Paper>
      </div>
    </MuiThemeProvider>
  );
};

export default ChooseReason;
